<template>
	<div class="page-con">
		<img src="@/assets/banner.png" />
		<div class="box-card">
			<div class="page-word">
				尊敬的职工朋友：<br />
				<span style="margin-left:36px;">
					您好！感谢您在百忙之中抽出时间参与本问卷调查，本问卷旨在了解您参与职工心理健康服务的真实感受和潜在需求，为您提供更精准的心理健康服务。本调查完全采用匿名方式进行，作答内容和个人信息将会严格保密。感谢您的支持与配合！
				</span>
			</div>
		</div>
		
		<div class="card-con">
			<van-form ref="form" @failed="onFailed">
				<div class="topic-title">一、服务体验与建议</div>
				<van-field name="radio" :required="true" label="1.近一年您参与各类心理健康服务的总次数：" :rules="rules.firstOption">
					<template #input>
						<van-radio-group v-model="form.firstOption" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">0次</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">1次</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="3">2-4次</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="4">5次及以上</van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="2.近一年您疏解情绪压力、调整心理状态的方式有：" :rules="rules.secondOption">
					<template #input>
						<van-checkbox-group v-model="form.secondOption" direction="horizontal"
							@change="(val) => select(val,'secondOption')">
							<div v-for="(item,index) in secondlist">
								<div class="row-label">
									<van-checkbox :name="item.value" shape="square">{{item.label}} </van-checkbox>
									<input v-if="item.label == '其他'" class="other-input" v-model="form.secondContent" />
								</div>
							</div>
						</van-checkbox-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="3.本次心理健康服务阵地体验过程中，您最喜欢的项目：" :rules="rules.thirdOption">
					<template #input>
						<van-radio-group v-model="form.thirdOption" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">心理知识讲座 </van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">团体辅导活动 </van-radio>
							</div>
							<div class="row-label">
								<van-radio name="3">功能室体验</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="4">其他</van-radio>
								<input class="other-input" v-model="form.thirdContent" />
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="4.目前中心阵地体验主要面向单位工会进行预约，如开放职工个人预约，您的预约意愿是："
					:rules="rules.fourthOption">
					<template #input>
						<van-radio-group v-model="form.fourthOption" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">愿意（期望<input class="other-input" style="width: 40px;margin-left: 5px;"
										v-model="form.fourthContent" />次/年）</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">不愿意 </van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="checkboxGroup" :required="true" label="5.中心持续推出以下心理健康服务形式，您最希望参与的是（最多选3项）："
					:rules="rules.fifthOption">
					<template #input>
						<van-checkbox-group v-model="form.fifthOption" direction="horizontal" max="3"
							@change="(val) => select(val,'fifthOption')">
							<div v-for="(item,index) in fifthlist">
								<div class="row-label">
									<van-checkbox :name="item.value" shape="square">{{item.label}} </van-checkbox>
								</div>
							</div>
						</van-checkbox-group>
					</template>
				</van-field>
				<van-field name="checkboxGroup" :required="true" label="6.以下心理健康相关话题中，您感兴趣的是（最多选3项）："
					:rules="rules.sixthOption">
					<template #input>
						<van-checkbox-group v-model="form.sixthOption" direction="horizontal" max="3"
							@change="(val) => select(val,'sixthOption')">
							<div v-for="(item,index) in sixthlist">
								<div class="row-label">
									<van-checkbox :name="item.value" shape="square">{{item.label}} </van-checkbox>
									<input v-if="item.label == '其他'" class="other-input" v-model="form.sixthContent" />
								</div>
							</div>
						</van-checkbox-group>
					</template>
				</van-field>
				<van-field v-model="form.seventhOption" :required="true" type="textarea"
					label="7.您参与职工心理健康服务的主要诉求（可简单描述当前的心理困扰等）：" :rules="rules.seventhOption" />
				<van-field v-model="form.eighthOption" :required="true" type="textarea"
					label="8.您对中心阵地心理健康服务有何意见建议，期待有进一步提升的部分是？" :rules="rules.eighthOption" />
				<div class="topic-title" style="margin-top: 5px;">二、个人信息</div>
				<van-field name="radio" :required="true" label="1.您的性别：" :rules="rules.sex">
					<template #input>
						<van-radio-group v-model="form.sex" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">男</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">女</van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="2.您的婚姻状况：" :rules="rules.isMarry">
					<template #input>
						<van-radio-group v-model="form.isMarry" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">未婚</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">已婚</van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="3.您的学历：" :rules="rules.education">
					<template #input>
						<van-radio-group v-model="form.education" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">高中或中专</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">大专</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="3">本科</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="4">研究生及以上</van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field name="radio" :required="true" label="4.您的工龄" :rules="rules.workYear">
					<template #input>
						<van-radio-group v-model="form.workYear" direction="horizontal">
							<div class="row-label">
								<van-radio name="1">0-2年</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="2">3-5年</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="3">5-10年</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="4">10-25年</van-radio>
							</div>
							<div class="row-label">
								<van-radio name="5">25年以上</van-radio>
							</div>
						</van-radio-group>
					</template>
				</van-field>
				<van-field v-model="form.workArea" :required="true" label="5.您的工作领域：" :rules="rules.workArea" />
			</van-form>
		</div>
		<div style="margin: 30px 70px;">
			<van-button round block type="info" native-type="submit" :disabled="btnDisabled" @click="onSubmit">确定</van-button>
		</div>
		<van-overlay :show="show">
			<div class="popup-con">
				<div class="popup">
					<img src="../../assets/Done.png" />
					<div class="popup-word">您已提交成功！</div>
					<div class="popup-btn" @click="onSure">确定</div>
				</div>
			</div>
		
		</van-overlay>
	</div>
</template>

<script>
	import {
		postForm
	} from "@/api/system/activity";
	import { Toast } from 'vant'
	export default {
		components: {

		},
		data() {
			return {
				show: false,
				btnDisabled:false,
				form: {},
				secondlist: [{
						label: "寻求专业人士帮助",
						value: 1
					},
					{
						label: "与家人和朋友倾诉",
						value: 2
					},
					{
						label: "运动娱乐自我放松",
						value: 3
					},
					{
						label: "阅读学习提升自我",
						value: 4
					},
					{
						label: "独自消化顺其自然",
						value: 5
					},
					{
						label: "其他",
						value: 6
					},
				],
				fifthlist: [{
						label: "心理知识讲座",
						value: 1
					},
					{
						label: "团体辅导活动",
						value: 2
					},
					{
						label: "个体心理咨询",
						value: 3
					},
					{
						label: "心理沙盘（团体/个体）",
						value: 4
					},
					{
						label: "心理卡牌（团体/个体）",
						value: 5
					}
				],
				sixthlist: [{
						label: "心理健康知识科普",
						value: 1
					},
					{
						label: "情绪压力管理实操",
						value: 2
					},
					{
						label: "人际交往社会适应",
						value: 3
					},
					{
						label: "婚恋情感需求分析",
						value: 4
					},
					{
						label: "家庭关系亲子教育",
						value: 5
					},
					{
						label: "职业发展个人成长",
						value: 6
					},
					{
						label: "其他",
						value: 7
					}
				],
				rules: {
					firstOption: [{
						required: true,
						message: '请选择选项'
					}],
					secondOption: [{
							required: true,
							message: '请选择选项'
						},
						{
							// 自定义表单校验
							validator: value => {
								if (value == 6) {
									return this.form.secondContent ? true : false
								} else {
									return true
								}
							},
							message: "请输入内容"
						}
					],
					thirdOption: [{
							required: true,
							message: '请选择选项'
						},
						{
							// 自定义表单校验
							validator: value => {
								if (value == 4) {
									return this.form.thirdContent ? true : false
								} else {
									return true
								}
							},
							message: "请输入内容"
						}
					],
					fourthOption: [{
							required: true,
							message: '请选择选项'
						},
						{
							// 自定义表单校验
							validator: value => {
								console.log(value)
								if (value.includes(1)) {
									return this.form.fourthContent ? true : false
								} else {
									return true
								}
							},
							message: "请输入内容"
						}
					],
					fifthOption: [{
						required: true,
						message: '请选择选项'
					}],
					sixthOption: [{
							required: true,
							message: '请选择选项'
						},
						{
							// 自定义表单校验
							validator: value => {
								console.log(value)
								if (value.includes(7)) {
									return this.form.sixthContent ? true : false
								} else {
									return true
								}
							},
							message: "请输入内容"
						}
					],
					seventhOption: [{
						required: true,
						message: '请输入内容'
					}],
					eighthOption: [{
						required: true,
						message: '请输入内容'
					}],
					sex: [{
						required: true,
						message: '请选择选项'
					}],
					isMarry: [{
						required: true,
						message: '请选择选项'
					}],
					education: [{
						required: true,
						message: '请选择选项'
					}],
					workYear: [{
						required: true,
						message: '请选择选项'
					}],
					workArea: [{
						required: true,
						message: '请输入内容'
					}]
				}
			};
		},
		created() {},
		mounted() {},
		methods: {
			validator(val) {
				return /1\d{10}/.test(val);
			},
			onFailed(errorInfo) {
				console.log('failed', errorInfo);
			},
			//多选
			select(val, name) {
				let arry = []
				if (name == "secondOption") {
					for (let i = 0; i < val.length; i++) {
						let index = val[i]
						arry.push(this.secondlist[index - 1].label)
					}
					this.form.secondTranslate = arry
				} else if (name == "fifthOption") {
					for (let i = 0; i < val.length; i++) {
						let index = val[i]
						arry.push(this.fifthlist[index - 1].label)
					}
					this.form.fifthTranslate = arry
				} else if (name == "sixthOption") {
					for (let i = 0; i < val.length; i++) {
						let index = val[i]
						arry.push(this.sixthlist[index - 1].label)
					}
					this.form.sixthTranslate = arry
				}
			},
			//提交
			onSubmit() {
				this.$refs.form.resetValidation()
				this.$refs.form.validate().then(() => {
					this.btnDisabled = true
					let data = {
						userId: localStorage.getItem("userId"),
						firstOption: this.form.firstOption,
						secondOption: this.form.secondOption.join(","),
						secondContent: this.form.secondContent,
						secondTranslate: this.form.secondTranslate.join(","),
						thirdOption: this.form.thirdOption,
						thirdContent: this.form.thirdContent,
						fourthOption: this.form.fourthOption,
						fourthContent: this.form.fourthContent,
						fifthOption: this.form.fifthOption.join(","),
						fifthTranslate: this.form.fifthTranslate.join(","),
						sixthOption: this.form.sixthOption.join(","),
						sixthContent: this.form.sixthContent,
						sixthTranslate: this.form.sixthTranslate.join(","),
						seventhOption: this.form.seventhOption,
						eighthOption: this.form.eighthOption,
						sex: this.form.sex,
						isMarry: this.form.isMarry,
						education: this.form.education,
						workYear: this.form.workYear,
						workArea: this.form.workArea
					}
					postForm(data).then(res => {
						if (res.code == 200) {
							this.show = true
							this.btnDisabled = false
						}else{
							this.btnDisabled = false
							Toast.fail("提交失败");
						}
					})
				}).catch(() => {
					let isError = document.getElementsByClassName("van-field__error-message");
					isError[0].scrollIntoView({
						block: 'center'
					})
				})
			},
			onSure() {
				this.$refs.form.resetValidation()
				this.form = new Object()
				this.show = false
			}
		}
	};
</script>
<style lang="scss" scoped>
	.page-con {
		padding-bottom: 10px;
		background:rgba(27, 105, 255, 1);
		height: 100%;
		position: relative;
		img{
			width: 100%;
			height: 180px;
		}
		
		.box-card{
			margin: 0 10px;
			position: relative;
			top: -20px;
			background-color: #4a63f6;
			padding: 10px 20px;
			border-radius: 15px;
			.page-word {
				font-size: 14px;
				font-weight: 400;
				color: rgba(250, 251, 253, 1);
				line-height: 20px;
			}
		}
		
		.card-con{
			background: #fff;
			padding: 10px 10px;
			border-radius: 20px;
			margin: -5px 10px 10px 10px;
			.topic-title {
				font-size: 18px;
				font-weight: 600;
				color: #000;
				margin-top: 5px;
			}
			
			.topic-label {
				font-size: 18px;
				font-weight: 500;
				color: #000;
				margin-top: 20px;
				line-height: 40px;
			}
			
			.other-input {
				border: none;
				border-bottom: 1px solid #e9e9e9;
				margin-left: -5px;
			}
			.row-label{
				display: flex;
			}
		}

		
		.popup-con {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;

			.popup {
				width: 305px;
				height: 290px;
				box-sizing: border-box;
				padding: 20px 20px;
				opacity: 1;
				border-radius: 20px;
				background: rgba(255, 255, 255, 1);
				box-shadow: 0px 11px 23px rgba(0, 0, 0, 0.18);
				display: flex;
				justify-content: center;
				flex-wrap: wrap;

				img {
					width: 164px;
					height: 107px;
				}

				.popup-word {
					font-size: 20px;
					font-weight: 700;
					letter-spacing: 0px;
					line-height: 28px;
					color: rgba(74, 74, 74, 1);
					text-align: center;
					vertical-align: top;

				}

				.popup-btn {
					width: 221.13px;
					height: 42px;
					opacity: 1;
					border-radius: 27.5px;
					background: rgba(27, 105, 253, 1);
					box-shadow: 0px 6px 12px rgba(27, 105, 253, 0.39);
					font-size: 16px;
					font-weight: 500;
					line-height: 42px;
					color: rgba(255, 255, 255, 1);
					text-align: center;
					vertical-align: top;

				}
			}
		}

	}

	::v-deep {
		.van-cell {
			position: relative;
			display: block !important;
			box-sizing: border-box;
			width: 100%;
			padding: 8px 16px 12px 16px;
			overflow: hidden;
			color: #323233;
			font-size: 14px;
			line-height: 24px;
			background-color: #fff;
		}

		.van-cell::after {
			border: none;
		}

		.van-field__label {
			box-sizing: border-box;
			width: 100% !important;
			font-size: 17px;
			font-weight: 700;
			color: #000;
			text-align: left;
		}

		.van-field__value {
			overflow: visible;
			border: 1px solid #e9e9e9;
			padding: 5px 10px;
			margin: 5px 0;
		}

		.van-field__error-message {
			color: #ee0a24;
			font-size: 12px;
			text-align: left;
			position: absolute;
			margin-top: 3px;
		}

		.van-radio--horizontal {
			margin-right: 12px;
			margin-bottom: 10px;
			margin-top: 10px;
		}

		.van-radio-group--horizontal {
			display: block !important;
		}

		.van-checkbox-group--horizontal {
			display: block !important;
		}

		.van-checkbox--horizontal {
			margin-right: 13px;
			margin-bottom: 10px;
			margin-top: 10px;
		}

		.van-button {
			background: #fff;
			color: rgba(27, 105, 255, 1);
			font-size: 16px;
			font-weight: 700;
			height: 42px;
			margin-right: 10px;
		}
		
		.van-button--info {
		    border: none;
		}
		
		.van-popup--bottom.van-popup--round {
			border-radius: 23px 23px 0 0;
		}
	}
</style>